import base from './base'
import contact from './contact'
import security from './security'

export const api = {
  base,
  security,
  contact,
}
